// src/hooks/useLegalData.ts
import { useState, useEffect } from 'react';
import { LegalDocument } from '../types'; // Импортируем наш контракт

export const useLegalData = () => {
  const [docs, setDocs] = useState<LegalDocument[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/legal-documents')
      .then(res => {
        if (!res.ok) throw new Error('Ошибка загрузки документов');
        return res.json();
      })
      .then((data: LegalDocument[]) => {
        // TypeScript теперь гарантирует, что data соответствует интерфейсу
        setDocs(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Failed to fetch legal docs:", err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return { docs, loading, error };
};
